import { createAction, props } from '@ngrx/store';

export const addToHistory = createAction(
  'ADD_TO_HISTORY',
  props<{ page: string }>()
);

export const clearHistory = createAction('CLEAR_HISTORY');
